import { NotificationItem } from './types'

const getEntityIdFromPath = (entityType: string, pathname: string): number | null => {
  const pattern =
    entityType === 'avito_hr_chat' ? /^\/hr\/(\d+)(?:\/|$)/ : /^\/(?:appeal|order)\/(\d+)(?:\/|$)/
  const match = pathname.match(pattern)
  return match ? Number(match[1]) : null
}

export const isViewingNotificationTarget = (
  notification: NotificationItem,
  pathname: string,
  search: string,
): boolean => {
  if (notification.type !== 'avito_incoming_message' || !notification.entity_key) {
    return false
  }

  const searchParams = new URLSearchParams(search)
  if (searchParams.get('tab') !== 'chats' || searchParams.get('chat') !== notification.entity_key) {
    return false
  }

  return getEntityIdFromPath(notification.entity_type, pathname) === notification.entity_id
}
